import React, { useEffect, useState, useCallback } from 'react';
import YouTube from 'react-youtube';
import { FaWhatsapp } from 'react-icons/fa';

import { useHistory } from 'react-router-dom';

import { Carousel } from 'react-responsive-carousel';
import api from '../../services/api';

import { useToast } from '../../hooks/toast';

import Logo from '../../assets/logo.svg';

import VarejoImg from '../../assets/images/segmento-varejo.png';
import AlimentacaoImg from '../../assets/images/segmento-alimentacao.png';
import CosmeticosImg from '../../assets/images/segmento-cosmetico.png';
import ModaImg from '../../assets/images/segmento-moda.png';

import Moda from '../../assets/gifs/segmento-moda.gif';
import Cosmetico from '../../assets/gifs/segmento-cosmetico.gif';
import Varejo from '../../assets/gifs/segmento-varejo.gif';
import Alimentacao from '../../assets/gifs/segmento-alimentacao.gif';

import {
  Container,
  Header,
  HomeSection,
  VideoSection,
  BenefitsSection,
  SaleStepsSection,
  BePartnerSection,
  DemoStoresSection,
  MobileMenu,
  WhatsappButton,
} from './styles';

const Contact: React.FC = () => {
  const [menuIsOpened, setMenuIsOpened] = useState(false);
  const [fullName, setFullName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [segments, setSegments] = useState<any[]>([]);
  const [selectedSegment, setSelectedSegment] = useState('');

  const { addToast } = useToast();
  const { push } = useHistory();

  useEffect(() => {
    async function loadSeguimentos(): Promise<void> {
      try {
        const response = await api.get('/seguimento');

        setSegments(
          response.data.map((seguimento: any) => ({
            value: seguimento.id,
            label: seguimento.descricao,
          })),
        );
      } catch (err) {
        addToast({
          title: 'Erro ao obter os seguimentos',
          description: (err as any).response?.data?.message || '',
          type: 'error',
        });
      }
    }

    loadSeguimentos();
  }, [addToast]);

  const handleToggleMenu = useCallback(() => {
    setMenuIsOpened((oldState) => !oldState);
  }, []);

  const handleChangePhone = useCallback((value: string | undefined) => {
    if (typeof value !== 'string') {
      return;
    }

    if (value.length >= 16) {
      return;
    }

    const maskedValue = value
      .replace(/\D/g, '')
      .replace(/(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{4})(\d)/, '$1-$2')
      .replace(/(\d{4})-(\d)(\d{4})/, '$1$2-$3');

    setPhoneNumber(maskedValue);
  }, []);

  const handleSubmit = useCallback(async () => {
    if (!fullName) {
      return addToast({
        title: 'Nome obrigatório',
        type: 'error',
      });
    }

    if (!phoneNumber) {
      return addToast({
        title: 'Telefone obrigatório',
        type: 'error',
      });
    }

    if (!selectedSegment) {
      return addToast({
        title: 'Segmento obrigatório',
        type: 'error',
      });
    }

    if (phoneNumber.length < 14) {
      return addToast({
        title: 'Telefone inválido',
        type: 'error',
      });
    }

    await api.post('/contato', {
      nome: fullName,
      email: 'Não informado',
      telefone: phoneNumber,
      seguimento: selectedSegment,
    });

    addToast({
      title: 'Sua solicitação foi enviada com êxito.',
      type: 'success',
    });

    push('/');
  }, [addToast, push, fullName, phoneNumber, selectedSegment]);

  return (
    <Container style={{ overflow: menuIsOpened ? 'hidden' : 'auto' }}>
      <Header>
        <nav>
          <img src={Logo} alt="ATAC Delivery" />
          <ul>
            <li>
              <a href="#benefits">Vantagens</a>
            </li>
            <li>
              <a href="#sales-steps">Como funciona</a>
            </li>
            <li>
              <a href="#demo-stores">Lojas de demonstração</a>
            </li>
            <button type="button" onClick={handleToggleMenu}>
              {menuIsOpened ? (
                <span className="material-icons-outlined">close </span>
              ) : (
                <span className="material-icons-outlined">menu</span>
              )}
            </button>
          </ul>
        </nav>
      </Header>
      <HomeSection id="home-section">
        <div className="background">
          <div className="container">
            <div className="content">
              <h1>
                <strong>PRAZER,</strong>
                <br />
                SOU SEU{' '}
                <strong>
                  NOVO
                  <br /> VENDEDOR
                </strong>{' '}
                VIRTUAL.
              </h1>
            </div>
            <div className="form-container">
              <div className="form-content">
                <h2>Solicite um convite para ser um parceiro</h2>
                <p>Aumente suas vendas e diminua seus custos agora mesmo</p>
                <div className="form">
                  <div className="input-content">
                    <label htmlFor="fullName">Nome completo</label>
                    <input
                      type="text"
                      id="fullName"
                      placeholder="Luan Costa Melo"
                      value={fullName}
                      onChange={(event) => setFullName(event.target.value)}
                    />
                  </div>
                  <div className="input-content">
                    <label htmlFor="phoneNumber">Telefone</label>
                    <input
                      type="text"
                      id="phoneNumber"
                      placeholder="(00) 00000-0000"
                      value={phoneNumber}
                      onChange={(event) =>
                        handleChangePhone(event.target.value)
                      }
                    />
                  </div>
                  <div className="input-content">
                    <label htmlFor="segment">Segmento</label>
                    <select
                      name="segment"
                      id="segment"
                      value={selectedSegment}
                      onChange={(event) => {
                        setSelectedSegment(event.target.value);
                      }}
                    >
                      <option value="">Selecione uma opção</option>
                      {segments.map((segment) => (
                        <option key={segment.value} value={segment.label}>
                          {segment.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <button type="submit" onClick={handleSubmit}>
                    Solicitar convite
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </HomeSection>
      <VideoSection>
        <h1>Por que o ATAC Delivery?</h1>
        <YouTube
          videoId="6RyKn1xvc70"
          id="6RyKn1xvc70"
          containerClassName="why-atac-video"
          opts={{
            height: '480',
          }}
        />
      </VideoSection>
      <BenefitsSection id="benefits">
        <h1>Quais são as vantagens de usar o ATAC Delivery?</h1>
        <div className="benefits-list">
          <div className="benefit-item">
            <span className="material-icons-outlined">done </span>
            <p>Seu cliente poderá pedir por vários canais digitais</p>
          </div>
          <div className="benefit-item">
            <span className="material-icons-outlined">done </span>
            <p>Plataforma livre de taxas</p>
          </div>
          <div className="benefit-item">
            <span className="material-icons-outlined">done </span>
            <p>Ajuda a diminuir os custos operacionais</p>
          </div>
          <div className="benefit-item">
            <span className="material-icons-outlined">done </span>
            <p>Exatidão nas suas operações de delivery</p>
          </div>
          <div className="benefit-item">
            <span className="material-icons-outlined">done </span>
            <p>Não precisa instalar nenhum aplicativo</p>
          </div>
        </div>
      </BenefitsSection>
      <SaleStepsSection id="sales-steps">
        <div className="container">
          <YouTube
            videoId="2zdPipXpv18"
            id="2zdPipXpv18"
            className="string"
            containerClassName="string"
            title="opa"
            opts={{
              height: '393',
              width: '222',
            }}
          />
          <div className="content">
            <h1>Como funciona o ATAC Delivery?</h1>
            <ol className="steps" start={50}>
              <li>
                <span>1.</span> Com uma interface fácil e amigável, nossa
                aplicação possui inteligência artificial que diminui seus custos
                operacionais, direcionando o pedido para a loja mais próxima do
                grupo
              </li>
              <li>
                <span>2.</span>Com apenas um click, o monitor de pedidos dispara
                a impressão dos produtos e envia a confirmação para o WhatsApp
                do cliente
              </li>
              <li>
                <span>3.</span>Além disso, você gerencia gráficos de vendas em
                tempo real e de períodos específicos
              </li>
              <li>
                <span>4.</span>Catálogo de produtos
              </li>
              <li>
                <span>5.</span>E muito mais...
              </li>
            </ol>
          </div>
        </div>
      </SaleStepsSection>
      <DemoStoresSection id="demo-stores">
        <h1>Lojas de demonstração</h1>
        <div className="container">
          <Carousel showArrows width="100%">
            <div className="demo-store">
              <img src={Cosmetico} alt="Cosméticos" />
              <div className="content">
                <h2>Cosméticos</h2>
                <a href="https://atacdelivery.com/makes" target="_blank">
                  Visitar
                </a>
              </div>
            </div>
            <div className="demo-store">
              {/* <video playsInline autoPlay loop src={Alimentacao} muted></video> */}
              {/* <img src={AlimentacaoImg} alt="Alimentação" /> */}
              <img src={Alimentacao} alt="Alimentação" />
              <div className="content">
                <h2>Alimentação</h2>
                <a
                  href="https://atacdelivery.com/restaurantedemo"
                  target="_blank"
                >
                  Visitar
                </a>
              </div>
            </div>
            <div className="demo-store">
              {/* <video playsInline autoPlay loop src={Moda} muted></video> */}
              {/* <img src={ModaImg} alt="Moda" /> */}
              <img src={Moda} alt="Moda" />
              <div className="content">
                <h2>Moda</h2>
                <a href="https://atacdelivery.com/modas" target="_blank">
                  Visitar
                </a>
              </div>
            </div>
            <div className="demo-store">
              {/* <video playsInline autoPlay loop src={Varejo} muted></video> */}
              {/* <img src={VarejoImg} alt="Varejo e Atacado" /> */}
              <img src={Varejo} alt="Varejo e Atacado" />
              <div className="content">
                <h2>Varejo e Atacado</h2>
                <a href="https://atacdelivery.com/atacado" target="_blank">
                  Visitar
                </a>
              </div>
            </div>
          </Carousel>
          <div className="demo-store xl">
            <img src={Cosmetico} alt="cosmetico" />
            <div className="content">
              <h2>Cosméticos</h2>
              <a href="https://atacdelivery.com/makes" target="_blank">
                Visitar
              </a>
            </div>
          </div>
          <div className="demo-store xl">
            <img src={Alimentacao} alt="Alimentação" />
            <div className="content">
              <h2>Alimentação</h2>
              <a
                href="https://atacdelivery.com/restaurantedemo"
                target="_blank"
              >
                Visitar
              </a>
            </div>
          </div>
          <div className="demo-store xl">
            <img src={Moda} alt="Moda" />
            <div className="content">
              <h2>Moda</h2>
              <a href="https://atacdelivery.com/modas" target="_blank">
                Visitar
              </a>
            </div>
          </div>
          <div className="demo-store xl">
            <img src={Varejo} alt="Varejo e Atacado" />
            <div className="content">
              <h2>Varejo e Atacado</h2>
              <a href="https://atacdelivery.com/atacado" target="_blank">
                Visitar
              </a>
            </div>
          </div>
        </div>
      </DemoStoresSection>

      <BePartnerSection>
        <div className="container">
          <h1>Está esperando o que?</h1>
          <a href="#home-section">Quero ser parceiro</a>
        </div>
      </BePartnerSection>
      <MobileMenu className={menuIsOpened ? 'opened' : 'closed'}>
        <img src={Logo} alt="ATAC Delivery" />
        <ul>
          <li>
            <a href="#benefits" onClick={() => setMenuIsOpened(false)}>
              Vantagens
            </a>
          </li>
          <li>
            <a href="#sales-steps" onClick={() => setMenuIsOpened(false)}>
              Como funciona
            </a>
          </li>
          <li>
            <a href="#demo-stores" onClick={() => setMenuIsOpened(false)}>
              Lojas de demonstração
            </a>
          </li>
        </ul>
      </MobileMenu>

      <WhatsappButton
        target="_blank"
        href="https://api.whatsapp.com/send?phone=559884027424&text=Ol%C3%A1%2C%20gostaria%20de%20cadastrar%20a%20minha%20empresa%20no%20Atac%20Delivery"
      >
        <FaWhatsapp />
      </WhatsappButton>
    </Container>
  );
};

export default Contact;
